import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./settings.css";

import Button from "react-bootstrap/Button";
import SettingsService from "./SettingsService.jsx";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import FormControl from "react-bootstrap/FormControl";
import Spinner from "react-bootstrap/Spinner";
import { AiFillCopy, AiOutlineClose, AiOutlineWarning } from "react-icons/ai";
import { TbProgress, TbProgressCheck } from "react-icons/tb";
import { FaCheck } from "react-icons/fa6";
import Switch from "react-switch";
import { utils } from "../../../utils/Utils.jsx";
import TeamManagement from "../team-management/TeamManagement.jsx";

class Settings extends Component {
  state = {
    isMobileWidth: false,
    account: {},

    accountType: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    companyDisplayName: "",
    companyLogoUrl: "",
    companyLogoLoadFailed: false,

    newFirstName: "",
    newLastName: "",

    authChoice: "",
    phoneValidated: false,
    emailValidated: false,
    idValidated: false,

    errorMessageType: "",

    qrcodeBase64: "",
    authKey: "",
    authKeyCopied: false,

    showGoogleAuthModal: false,
    showDisableAccountModal: false,

    disableType: "",
    disableAccountStage: 1,
    disableAccountCode: "",
    invalidDisableAccountCode: false,

    confirmPhoneMessage: "",
    loadingPhone: false,

    loading: true,

    sentNumber: 0,
    finishedNumber: 0,
    changeInfoResults: [],

    navigationPicked: "account-info",

    loadingSentAuthChange: false,
    loadingSentDisableAccount: false,
  };

  service = new SettingsService();
  vstyle = getComputedStyle(document.body);

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    console.log("this.props.history settings", this.props.history);
    this.service.getClientConfig(this.props.token, this.setState.bind(this));

    utils.checkWindowWidth(
      this.setState.bind(this),
      this.props.changeGoBackNavBar.bind(this),
      true,
      "/dashboard",
    );
    window.addEventListener(
      "resize",
      utils.checkWindowWidth.bind(
        this,
        this.setState.bind(this),
        this.props.changeGoBackNavBar.bind(this),
        true,
        "/dashboard",
      ),
    );
  }

  componentDidUpdate(prevProps, prevState) {}

  componentWillUnmount() {}

  goToURL = (url) => {
    this.props.history.push({ pathname: url, megastate: { from: "vendors" } });
  };

  handleLogoLoadError = () => {
    this.setState({ companyLogoLoadFailed: true });
  };

  copyText = () => {
    this.setState({
      authKeyCopied: true,
    });
    navigator.clipboard.writeText(this.state.authKey);
  };

  changeAuthMethod = () => {
    this.setState(
      {
        loadingSentAuthChange: true,
      },
      () => {
        if (this.state.authChoice == "Google Auth") {
          this.service.decline2FA(this.props.token, this.setState.bind(this));
        } else {
          this.service.alwasyOn2FA(this.props.token, this.setState.bind(this));
        }
      },
    );
  };

  handleAuthModalClose = () => {
    this.setState({
      showGoogleAuthModal: false,
    });
  };

  handleDeleteModalOpen = () => {
    this.setState({
      disableType: "delete",
      disableAccountStage: 1,
      showDisableAccountModal: true,
    });
  };

  handleDeactivateModalOpen = () => {
    this.setState({
      disableType: "deactivate",
      disableAccountStage: 1,
      showDisableAccountModal: true,
    });
  };

  handleDisableModalClose = () => {
    this.setState({
      showDisableAccountModal: false,
    });
  };

  saveAccountInfo = () => {
    if (
      this.state.firstName != this.state.newFirstName ||
      this.state.lastName != this.state.newLastName
    ) {
      this.setState(
        {
          sentNumber: this.state.sentNumber + 1,
        },
        () => {
          this.service.changeName(
            this.props.token,
            this.state,
            this.setState.bind(this),
          );
        },
      );
    }
  };

  cancelSaveAccountInfo = () => {
    this.setState({
      newFirstName: this.state.firstName,
      newLastName: this.state.lastName,
    });
  };

  getResultMessage = () => {
    if (
      this.state.sentNumber > 0 &&
      this.state.sentNumber == this.state.finishedNumber
    ) {
      if (this.state.changeInfoResults.some((r) => r)) {
        this.setState(
          {
            errorMessageType: "",
          },
          () => {
            this.setMessages("the-information-was-updated-successfully");
          },
        );
      } else {
        this.setState(
          {
            errorMessageType: "",
          },
          () => {
            this.setMessages(
              "there-was-a-problem-saving-some-of-the-information",
            );
          },
        );
      }
    } else {
      this.setState({
        errorMessageType: "",
      });
    }
  };

  setMessages = (type) => {
    this.setState({
      errorMessageType: type,
    });
  };

  confirmPhone = () => {
    this.setState(
      {
        loadingPhone: true,
      },
      () => {
        this.service.confirmPhone(this.props.token, this.setState.bind(this));
      },
    );
  };

  moveDisableAccountStage = () => {
    this.setState(
      {
        disableAccountStage: this.state.disableAccountStage + 1,
      },
      () => {
        if (this.state.authChoice == "Phone") {
          this.confirmPhone();
        }
      },
    );
  };

  goToChangePhone = () => {
    this.props.history.push({
      pathname: "/dashboard/settings/change-phone",
      megastate: {
        phone: this.state.phone,
      },
    });
  };

  goToChangeEmail = () => {
    this.props.history.push({
      pathname: "/dashboard/settings/change-email",
      megastate: {
        email: this.state.email,
      },
    });
  };

  goToChangePassword = () => {
    this.props.history.push({
      pathname: "/change-password",
      megastate: {
        fromSettings: true,
      },
    });
  };

  goToVerifyPhone = () => {
    this.props.history.push({
      pathname: "/dashboard/settings/verify-phone",
      megastate: {
        fromSettings: true,
      },
    });
  };

  goToVerifyEmail = () => {
    this.props.history.push({
      pathname: "/dashboard/settings/verify-email",
      megastate: {
        fromSettings: true,
      },
    });
  };

  goToVerifyIdentity = () => {
    this.props.history.push({
      pathname: "/dashboard/settings/id-verification",
      megastate: {
        fromSettings: true,
      },
    });
  };

  goToDisableAccountResultPage = (value) => {
    if (value) {
      this.props.history.push({
        pathname: "/result",
        megastate: {
          success: value,
          type: this.state.disableType + "-account",
          primaryButtonFunction: utils.goToURL.bind(this, this.props, "/"),
          secondButton: false,
        },
      });
    } else {
      this.props.history.push({
        pathname: "/result",
        megastate: {
          success: value,
          type: this.state.disableType + "-account",
          primaryButtonFunction: utils.goToURL.bind(this, this.props, "/"),
          secondButton: false,
        },
      });
    }
  };

  disableAccount = () => {
    if (
      this.state.disableAccountCode != "" &&
      this.state.disableAccountCode.length > 5
    ) {
      this.setState({ loadingSentDisableAccount: true }, () => {
        if (this.state.disableType == "delete") {
          this.service.deleteAccount(
            this.props.token,
            this.state.disableAccountCode,
            this.goToDisableAccountResultPage.bind(this),
          );
        } else {
          this.service.deactivateAccount(
            this.props.token,
            this.state.disableAccountCode,
            this.goToDisableAccountResultPage.bind(this),
          );
        }
      });
    } else {
      this.setState({ invalidDisableAccountCode: true });
    }
  };

  goBack = () => {
    this.props.history.goBack();
  };

  getDisableModalTitle = () => {
    console.log("this.state.disableType", this.state.disableType);
    if (this.state.disableType == "delete") {
      return this.props.localizedText["permanently-delete-account"];
    } else if (this.state.disableType == "deactivate") {
      return this.props.localizedText["deactivate-account"];
    }
  };

  getDisableModalBody = () => {
    if (this.state.disableType == "delete") {
      return this.props.localizedText[
        "before-you-go-on-are-you-really-sure-that-you-want-to-delete-your-account"
      ];
    } else if (this.state.disableType == "deactivate") {
      return this.props.localizedText[
        "deactivating-your-account-will-temporarily-suspend-your-access.-your-data-will-be-retained,-but-you-won't-be-able-to-use-the-platform-until-you-reactivate-your-account."
      ];
    }
  };

  getDisableModalButton = () => {
    if (this.state.disableType == "delete") {
      return this.props.localizedText["delete"];
    } else if (this.state.disableType == "deactivate") {
      return this.props.localizedText["deactivate"];
    }
  };

  goToRegisterNewPassCode = () => {
    this.props.history.push({
      pathname: "/pass-code",
      megastate: {
        type: "registerNewPassCode",
        goBackUrl: "/dashboard/settings",
      },
    });
  };

  render() {
    return (
      <React.Fragment>
        <div class="settings-container page-container">
          <div class="middle-container">
            {this.state.loading ? (
              <div class="loader-div fade-in-up">
                <Spinner className="loader-outside"></Spinner>
              </div>
            ) : (
              <div class="container-padding fade-in-up">
                <div class="title">{this.props.localizedText["settings"]}</div>

                <div className="accordion-settings">
                  <div class="settings-row-div">
                    <div class="settings-row-div-header">
                      {this.props.localizedText["account-info"]}
                    </div>

                    <div class="info-row">
                      <div>{this.props.localizedText["account-type"]}</div>

                      <div>
                        {this.state.accountType == "individual"
                          ? this.props.localizedText["individual"]
                          : this.props.localizedText["business"]}
                      </div>
                    </div>

                    {this.state.companyDisplayName &&
                    this.state.accountType !== "individual" ? (
                      <div class="company-banner">
                        {this.state.companyLogoUrl &&
                        !this.state.companyLogoLoadFailed ? (
                          <img
                            src={this.state.companyLogoUrl}
                            alt={this.state.companyDisplayName}
                            onError={this.handleLogoLoadError}
                          />
                        ) : null}
                        <div class="company-banner-name">
                          {this.state.companyDisplayName}
                        </div>
                      </div>
                    ) : null}

                    {this.state.companyDisplayName &&
                    this.state.accountType !== "individual" ? (
                      <div class="info-row">
                        <div>
                          {this.props.localizedText["account-holder"]}
                        </div>
                        <div>
                          {(this.state.firstName || "") +
                            " " +
                            (this.state.lastName || "")}
                        </div>
                      </div>
                    ) : null}

                    <div class="account-info">
                      <Form.Group className="mb-3">
                        <Form.Label className="input-label-outside-div">
                          {this.props.localizedText["first-name"]}
                        </Form.Label>
                        <FormControl
                          name="newFirstName"
                          value={this.state.newFirstName}
                          onChange={(e) =>
                            utils.handleChange(e, this.setState.bind(this))
                          }
                          className="input-field"
                          disabled={this.state.loadingSent}
                          autoComplete="off"
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label className="input-label-outside-div">
                          {this.props.localizedText["last-name"]}
                        </Form.Label>
                        <FormControl
                          name="newLastName"
                          value={this.state.newLastName}
                          onChange={(e) =>
                            utils.handleChange(e, this.setState.bind(this))
                          }
                          className="input-field"
                          disabled={this.state.loadingSent}
                          autoComplete="off"
                        />
                      </Form.Group>

                      <div class="bottom-section-div">
                        <div
                          class={
                            this.state.changeInfoResults.some((r) => r)
                              ? "result-message success"
                              : "result-message danger"
                          }
                        >
                          {
                            this.props.localizedText[
                              this.state.errorMessageType
                            ]
                          }
                        </div>
                        <div class="closer-buttons-div">
                          <Button
                            className="small-button outside-primary-button"
                            disabled={
                              this.state.firstName == this.state.newFirstName &&
                              this.state.lastName == this.state.newLastName &&
                              this.state.phone == this.state.newPhone
                            }
                            onClick={this.saveAccountInfo}
                          >
                            {this.state.sentNumber !=
                            this.state.finishedNumber ? (
                              <Spinner className="loader-send-outside-div-button"></Spinner>
                            ) : null}
                            {this.props.localizedText["save"]}
                          </Button>
                          <Button
                            className="small-button outside-secondary-button"
                            onClick={this.cancelSaveAccountInfo}
                          >
                            {this.props.localizedText["cancel"]}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="settings-row-div">
                    <div class="settings-row-div-header">
                      {this.props.localizedText["security"]}
                    </div>

                    <div class="verification-div">
                      <div class="sub-title">
                        {this.props.localizedText["pass-code"]}
                      </div>

                      <div class="verification-info-div">
                        <div class="current-verified">******</div>
                        <Button
                          className="small-button outside-primary-button"
                          onClick={this.goToRegisterNewPassCode}
                        >
                          {this.props.localizedText["change-pass-code"]}
                        </Button>
                      </div>
                    </div>
                    <div class="verification-div">
                      <div class="sub-title">
                        {this.props.localizedText["phone"]}
                      </div>

                      <div class="verification-info-div">
                        <div class="current-verified">{this.state.phone}</div>
                        <Button
                          className="small-button outside-primary-button"
                          onClick={this.goToChangePhone}
                        >
                          {this.props.localizedText["change-phone-number"]}
                        </Button>
                      </div>
                    </div>
                    <div class="verification-div">
                      <div class="sub-title">
                        {this.props.localizedText["email-address"]}
                      </div>

                      <div class="verification-info-div">
                        <div class="current-verified">{this.state.email}</div>
                        <Button
                          className="small-button outside-primary-button"
                          onClick={this.goToChangeEmail}
                        >
                          {this.props.localizedText["change-email"]}
                        </Button>
                      </div>
                    </div>
                    <div class="verification-div">
                      <div class="sub-title">
                        {this.props.localizedText["password"]}
                      </div>

                      <div class="verification-info-div">
                        <div class="current-verified">********</div>
                        <Button
                          className="small-button outside-primary-button"
                          onClick={this.goToChangePassword}
                        >
                          {this.props.localizedText["change-password"]}
                        </Button>
                      </div>
                    </div>
                    <div class="verification-div">
                      <div class="sub-title">
                        {this.props.localizedText["change-auth-method"]}
                      </div>

                      <div class="verification-info-div">
                        <div class="current-verified">
                          {this.props.localizedText["current-method"] + ": "}
                          {this.state.authChoice}
                        </div>
                        <div class="toggle-button-div">
                          {this.state.loadingSentAuthChange ? (
                            <Spinner className="loader-small-outside "></Spinner>
                          ) : null}
                          <Switch
                            checkedIcon={null}
                            uncheckedIcon={null}
                            onChange={this.changeAuthMethod}
                            activeBoxShadow={null}
                            onColor={this.vstyle.getPropertyValue(
                              "--inside-success-color",
                            )}
                            checked={this.state.authChoice == "Google Auth"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="settings-row-div">
                    <div class="settings-row-div-header">
                      {this.props.localizedText["verification"]}
                    </div>

                    <div class="verification-div">
                      <div class="sub-title">
                        {this.props.localizedText["phone-verification"]}
                      </div>
                      {this.state.phoneValidated ? (
                        <div class="verification-info-div">
                          <div class="current-verified">
                            <FaCheck className="verified-icon" />
                            {this.props.localizedText["phone-is-verified"]}
                          </div>
                        </div>
                      ) : (
                        <div class="verification-info-div">
                          <div class="current-verified">
                            <AiOutlineClose className="not-verified-icon" />
                            {this.props.localizedText["phone-is-not-verified"]}
                          </div>
                          <Button
                            className="small-button outside-primary-button"
                            onClick={this.goToVerifyPhone}
                          >
                            {this.props.localizedText["verify-phone"]}
                          </Button>
                        </div>
                      )}
                    </div>
                    <div class="verification-div">
                      <div class="sub-title">
                        {this.props.localizedText["email-verification"]}
                      </div>
                      {this.state.emailValidated ? (
                        <div class="verification-info-div">
                          <div class="current-verified">
                            <FaCheck className="verified-icon" />
                            {this.props.localizedText["email-is-verified"]}
                          </div>
                        </div>
                      ) : (
                        <div class="verification-info-div">
                          <div class="current-verified">
                            <AiOutlineClose className="not-verified-icon" />
                            {this.props.localizedText["email-is-not-verified"]}
                          </div>
                          <Button
                            className="small-button outside-primary-button"
                            onClick={this.goToVerifyEmail}
                          >
                            {this.props.localizedText["verify-email"]}
                          </Button>
                        </div>
                      )}
                    </div>
                    <div class="verification-div">
                      <div class="sub-title">
                        {this.props.localizedText["id-verification"]}
                      </div>
                      {this.state.idValidated ? (
                        <div class="verification-info-div">
                          <div class="current-verified">
                            <FaCheck className="verified-icon" />
                            {this.props.localizedText["id-is-verified"]}
                          </div>
                        </div>
                      ) : (
                        <div class="verification-info-div">
                          <div class="current-verified">
                            <AiOutlineClose className="not-verified-icon" />
                            {this.props.localizedText["id-is-not-verified"]}
                          </div>
                          <Button
                            className="small-button outside-primary-button"
                            onClick={this.goToVerifyIdentity}
                          >
                            {this.props.localizedText["verify-identity"]}
                          </Button>
                        </div>
                      )}
                    </div>

                    {process.env.REACT_APP_ENV !== "prod" ||
                    this.state.domicile === "US" ? (
                      <div class="verification-div">
                        <div class="sub-title">
                          {this.props.localizedText["private-bank-account"]}
                        </div>
                        {this.state.bankAccountVerified == null ||
                        this.state.bankAccountVerified == "none" ? (
                          <div class="verification-info-div">
                            <div class="current-verified">
                              <AiOutlineClose className="not-verified-icon" />
                              {
                                this.props.localizedText[
                                  "private-bank-account-has-not-been-created"
                                ]
                              }
                            </div>
                            <Button
                              className="small-button outside-primary-button"
                              onClick={utils.goToURL.bind(
                                this,
                                this.props,
                                "/dashboard/settings/bank-account-verification",
                              )}
                            >
                              {
                                this.props.localizedText[
                                  "create-private-bank-account"
                                ]
                              }
                            </Button>
                          </div>
                        ) : this.state.bankAccountVerified == "Failed" ? (
                          <div class="verification-info-div">
                            <div class="current-verified">
                              <AiOutlineClose className="not-verified-icon" />
                              {
                                this.props.localizedText[
                                  "private-account-creation-failed"
                                ]
                              }
                            </div>

                            <Button
                              className="small-button outside-primary-button"
                              onClick={utils.goToURL.bind(
                                this,
                                this.props,
                                "/dashboard/settings/bank-account-verification",
                              )}
                            >
                              {this.props.localizedText["restart-creation"]}
                            </Button>
                          </div>
                        ) : this.state.bankAccountVerified == "Pending" ? (
                          <div class="verification-info-div">
                            <div class="text-info-div">
                              <div class="current-verified">
                                <TbProgress className="no-state-icon" />
                                {
                                  this.props.localizedText[
                                    "creation-is-pending"
                                  ]
                                }
                              </div>
                              <div class="notification-message">
                                {
                                  this.props.localizedText[
                                    "approval-will-take-approximately-3-to-5-business-days"
                                  ]
                                }
                              </div>
                            </div>
                            <Button
                              className="small-button outside-primary-button"
                              onClick={() => {
                                this.setState(
                                  {
                                    loading: true,
                                  },
                                  () => {
                                    this.service.getClientConfig(
                                      this.props.token,
                                      this.setState.bind(this),
                                    );
                                  },
                                );
                              }}
                            >
                              {this.props.localizedText["refresh-status"]}
                            </Button>
                          </div>
                        ) : this.state.bankAccountVerified == "InProgress" ? (
                          <div class="verification-info-div">
                            <div class="current-verified">
                              <TbProgressCheck className="no-state-icon" />

                              {
                                this.props.localizedText[
                                  "bank-account-is-being-processed"
                                ]
                              }
                            </div>
                            <Button
                              className="small-button outside-primary-button"
                              onClick={() => {
                                this.setState(
                                  {
                                    loading: true,
                                  },
                                  () => {
                                    this.service.getClientConfig(
                                      this.props.token,
                                      this.setState.bind(this),
                                    );
                                  },
                                );
                              }}
                            >
                              {this.props.localizedText["refresh-status"]}
                            </Button>
                          </div>
                        ) : (
                          <div class="verification-info-div">
                            <div class="current-verified">
                              {this.props.localizedText["bank-account-is-open"]}
                            </div>
                            <Button
                              className="small-button outside-primary-button"
                              onClick={() =>
                                window.open(
                                  "https://cybrid.xyz/hubfs/20592480/Legal/Cybrid-User-Agreement_COMBINED.pdf",
                                  "_blank",
                                )
                              }
                            >
                              {this.props.localizedText["see-user-agreement"]}
                            </Button>
                          </div>
                        )}
                      </div>
                    ) : null}
                  </div>
                  {process.env.REACT_APP_ENV !== "prod" ? (
                    <div class="settings-row-div">
                      <div class="settings-row-div-header">
                        Deposit For Development
                      </div>

                      <div class="verification-info-div">
                        <Button
                          className="small-button outside-primary-button"
                          onClick={utils.goToURL.bind(
                            this,
                            this.props,
                            "/dashboard/hidden/deposit-dev",
                          )}
                        >
                          Go to Deposit Dev
                        </Button>
                      </div>
                    </div>
                  ) : null}
                  <div class="settings-row-div">
                    <div class="settings-row-div-header">
                      Diagnostics
                    </div>

                    <div class="disable-div" style={{ background: "rgba(34, 197, 94, 0.04)", border: "1px solid rgba(34, 197, 94, 0.18)" }}>
                      <div class="description">
                        Pack browser, build, account, and recent route info into a debug report and send it to Blox support. Useful when something looks off and you want us to see it the way you see it.
                      </div>
                      <div class="disable-buttons-div">
                        <Button
                          className="primary-button outside-primary-button top-button"
                          onClick={() => {
                            const cfg = this.props.config || {};
                            const ua = navigator.userAgent;
                            const buildVersion = (typeof window !== "undefined" && window.localStorage)
                              ? (window.localStorage.getItem("appBuildVersion") || "unknown")
                              : "unknown";
                            const timestamp = new Date().toISOString();
                            const lines = [
                              "Blox Portal Debug Report",
                              "------------------------",
                              `Generated: ${timestamp}`,
                              `Build: ${buildVersion}`,
                              `Path: ${window.location.pathname}${window.location.search}`,
                              `User Agent: ${ua}`,
                              `Viewport: ${window.innerWidth}x${window.innerHeight}`,
                              `Pixel ratio: ${window.devicePixelRatio || 1}`,
                              `Theme: ${this.props.theme || "unknown"}`,
                              `Region: ${this.props.region || "unknown"}`,
                              "",
                              "Account",
                              `  Email: ${cfg.email || ""}`,
                              `  Phone: ${cfg.phone || ""}`,
                              `  Company: ${cfg.company_display_name || ""}`,
                              `  Domicile: ${cfg.domicile || ""}`,
                              `  KYC: ${cfg.kyc_completed ? "yes" : "no"}`,
                              `  Email validated: ${cfg.email_validated ? "yes" : "no"}`,
                              `  Phone validated: ${cfg.phone_validated ? "yes" : "no"}`,
                              "",
                              "Describe what you were doing when this happened:",
                              "",
                              "(your description here)",
                              "",
                            ];
                            const body = lines.join("\n");
                            const subject = `Blox debug report · ${cfg.email || "user"} · ${timestamp.slice(0, 19)}`;
                            /* Try clipboard copy first so the user has a fallback if mail
                               client isn't installed; then open mailto. */
                            if (navigator.clipboard) {
                              navigator.clipboard.writeText(body).catch(() => {});
                            }
                            const mailto = `mailto:support@bloxcross.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
                            window.location.href = mailto;
                          }}
                        >
                          Send debug report
                        </Button>
                      </div>
                    </div>
                  </div>

                  {/* Team management (V3 §J). Lives in legacy Settings
                      because it's reachable from both the legacy
                      dashboard and the new terminal via UtilBar. */}
                  <TeamManagement
                    token={this.props.token}
                    currentUserEmail={this.state.email}
                  />

                  <div class="settings-row-div">
                    <div class="settings-row-div-header">
                      {this.props.localizedText["delete-account"]}
                    </div>

                    <div class="disable-div">
                      <div class="description">
                        {
                          this.props.localizedText[
                            "permanently-or-temporarily-suspend-your-account's-activity"
                          ]
                        }
                      </div>
                      <div class="disable-buttons-div">
                        <Button
                          className="outside-danger-button top-button"
                          onClick={this.handleDeactivateModalOpen}
                        >
                          {this.props.localizedText["deactivate-account"]}
                        </Button>

                        <Button
                          className="outside-danger-button"
                          onClick={this.handleDeleteModalOpen}
                        >
                          {this.props.localizedText["delete-account"]}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <Modal
            show={this.state.showGoogleAuthModal}
            onHide={this.handleAuthModalClose}
            className="settings-modal"
            centered
          >
            <Modal.Header>
              <Modal.Title>
                {this.props.localizedText["google-authenticator"]}
              </Modal.Title>
              <AiOutlineClose
                className="close-button"
                onClick={this.handleAuthModalClose}
              />
            </Modal.Header>
            <Modal.Body>
              {
                this.props.localizedText[
                  "please-save-this-within-your-authenticator-app"
                ]
              }
              <img
                className="qrcode"
                src={`data:image/png;base64, ${this.state.qrcodeBase64}`}
              />
              <div class="key-div" onClick={this.copyText}>
                {this.props.localizedText["key"] + ":"}
                <div class="key">
                  {this.state.authKey}
                  {this.state.authKeyCopied ? (
                    <FaCheck class="copy-success-icon" />
                  ) : (
                    <AiFillCopy class="copy-key-icon" />
                  )}
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="small-button outside-secondary-button"
                onClick={this.handleAuthModalClose}
              >
                {this.props.localizedText["close"]}
              </Button>
              <Button
                className="small-button outside-primary-button"
                onClick={this.handleAuthModalClose}
              >
                {this.props.localizedText["continue"]}
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.showDisableAccountModal}
            onHide={this.handleDisableModalClose}
            className="settings-modal"
            centered
          >
            <Modal.Header>
              <Modal.Title>
                <AiOutlineWarning className="warning-icon danger" />
                {this.getDisableModalTitle()}
              </Modal.Title>
              <AiOutlineClose
                className="close-button"
                onClick={this.handleDisableModalClose}
              />
            </Modal.Header>

            {this.state.disableAccountStage == 1 ? (
              <Modal.Body>{this.getDisableModalBody()}</Modal.Body>
            ) : (
              <Modal.Body>
                {!this.state.loadingPhone ? (
                  <>
                    <Form.Group className="mb-3">
                      <Form.Label className="input-label-outside-div">
                        {this.props.localizedText["verification-code"]}
                      </Form.Label>
                      <FormControl
                        name="disableAccountCode"
                        value={this.state.disableAccountCode}
                        onChange={(e) =>
                          utils.handleChange(e, this.setState.bind(this))
                        }
                        isInvalid={this.state.invalidDisableAccountCode}
                        className="input-field"
                        disabled={this.state.loadingSentDisableAccount}
                      />
                    </Form.Group>
                    {this.state.authChoice == "Phone" ? (
                      <div>
                        {
                          this.props.localizedText[
                            "a-text-message-with-a-8-digit-verification-code-was-just-sent-to"
                          ]
                        }
                        {this.state.confirmPhoneMessage + " "}
                        <b onClick={this.confirmPhone}>
                          {this.props.localizedText["resend-code"]}
                        </b>
                      </div>
                    ) : (
                      <div>
                        {
                          this.props.localizedText[
                            "please-enter-the-code-from-your-authenticator-app"
                          ]
                        }
                      </div>
                    )}
                  </>
                ) : (
                  <Spinner className="loader" />
                )}
              </Modal.Body>
            )}
            <Modal.Footer>
              <Button
                className="small-button outside-secondary-button"
                onClick={this.handleDisableModalClose}
              >
                {this.props.localizedText["close"]}
              </Button>
              {this.state.disableAccountStage == 1 ? (
                <Button
                  className="small-button outside-primary-button"
                  onClick={this.moveDisableAccountStage}
                >
                  {this.props.localizedText["continue"]}
                </Button>
              ) : (
                <Button
                  className="small-button outside-primary-button"
                  onClick={this.disableAccount}
                  disabled={this.state.loadingSentDisableAccount}
                >
                  {this.state.loadingSentDisableAccount ? (
                    <Spinner className="loader-send-outside-div-button"></Spinner>
                  ) : null}
                  {this.getDisableModalButton()}
                </Button>
              )}
            </Modal.Footer>
          </Modal>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(Settings);
